export default "__VITE_ASSET__BoDQzD3O__"